import React from 'react';

const BasketballPitch = ({ lineup }) => {
    return (
        <main className="lineup-main">
            <div className="pitch-container">
                {/* Agregamos una clase extra 'basketball-pitch' por si necesitas ajustar escalas en SASS */}
                <div className="pitch basketball-pitch">
                    
                    {/* Marcas de la Duela */}
                    <div className="center-line"></div>
                    <div className="center-circle"></div>
                    
                    {/* Zonas pintadas (La llave) */}
                    <div className="paint-area paint-left"></div>
                    <div className="paint-area paint-right"></div>
                    
                    {/* Arcos de tiros libres */}
                    <div className="free-throw-circle ft-left"></div>
                    <div className="free-throw-circle ft-right"></div>
                    
                    {/* Líneas de 3 puntos */}
                    <div className="three-point-line tp-left"></div>
                    <div className="three-point-line tp-right"></div>

                    {/* Contenedor de Jugadores */}
                    <div className="players-container">
                        {lineup.players.map((p, idx) => (
                            <div key={`${p.playerId}-${idx}`} className="player-card" style={{ left: `${p.positionX}%`, top: `${p.positionY}%` }}>
                                <div className="kit-circle">
                                    {p.dorsal}
                                    {p.isCaptain && <div className="captain-badge">C</div>}
                                </div>
                                <div className="player-info">
                                    <div className="player-name">{p.name}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Head Coach */}
            <div className="dt-card left">
                <div className="kit-circle dt-kit">HC</div>
                <div className="player-info">
                    <div className="player-name">{lineup.managerName}</div>
                </div>
            </div>
        </main>
    );
};

export { BasketballPitch };